export default function About() {
  return (
    <section id="about" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="relative">
            <div className="rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://static.readdy.ai/image/b12b9a0ca9e4c1ccf1aa04e1d4b67e89/d558d7dcf396fdd7dee3c09947023c45.jpeg"
                alt="Professional adjuster with client"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute bottom-6 left-6 right-6 flex gap-3">
              <div className="bg-white/95 backdrop-blur-sm rounded-lg px-4 py-3 shadow-lg flex-1">
                <div className="text-xs text-gray-600 mb-1">Licensed</div>
                <div className="text-sm font-bold text-[#1e3a5f]">NJ, PA, MD</div>
              </div>
              <div className="bg-white/95 backdrop-blur-sm rounded-lg px-4 py-3 shadow-lg flex-1">
                <div className="text-xs text-gray-600 mb-1">Certified</div>
                <div className="text-sm font-bold text-[#1e3a5f]">Public Adjuster</div>
              </div>
              <div className="bg-white/95 backdrop-blur-sm rounded-lg px-4 py-3 shadow-lg flex-1">
                <div className="text-xs text-gray-600 mb-1">Insured</div>
                <div className="text-sm font-bold text-[#1e3a5f]">Bonded</div>
              </div>
            </div>
          </div>

          <div>
            <div className="text-[#FF6B35] text-sm font-bold uppercase tracking-wider mb-3">Who We Are</div>
            <h2 className="text-5xl font-bold text-[#1e3a5f] mb-6">Your Advocate Against Underpayment</h2>
            <div className="space-y-4 text-base text-gray-600 leading-relaxed">
              <p>
                Most policyholders only learn what their insurance truly covers after a loss. Claim It Assist is a dedicated public adjusting service with decades of insurance experience.
              </p>
              <p>
                We specialize in helping property owners understand their policy, uncover hidden damage, and receive the full settlement needed to restore their home or business.
              </p>
              <p>
                With over 25 years of combined industry experience, we know how insurers operate, and we counter delays, underpayments, and misinterpretations with expertise and persistence.
              </p>
            </div>

            <div className="mt-8 pl-6 border-l-4 border-[#FF6B35]">
              <p className="text-xl italic text-[#1e3a5f] leading-relaxed">
                "Your insurance company has experts working for them. You should too."
              </p>
            </div>

            <div className="mt-8">
              <div className="text-sm text-gray-500">Founder & Lead Adjuster</div>
              <div className="text-lg font-bold text-[#1e3a5f]">Licensed Public Adjuster</div>
            </div>

            <div className="mt-8 grid grid-cols-3 gap-6">
              <div>
                <div className="text-3xl font-bold text-[#FF6B35] mb-1">25+</div>
                <div className="text-sm text-gray-600">Combined Years of Experience</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-[#FF6B35] mb-1">1000+</div>
                <div className="text-sm text-gray-600">Claims Handled</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-[#FF6B35] mb-1">$50M+</div>
                <div className="text-sm text-gray-600">Recovered</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
